module.exports = __webpack_public_path__ + "static/media/pheasant_specification.00003a61.md";